<form [formGroup]="form">
    <nz-row>
        <nz-col [nzFlex]="'300px'">
            <nz-form-item>
                <nz-form-label>{{resolveKey("RoleName") | translate}}</nz-form-label>
                <nz-form-control>
                    <input nz-input formControlName="displayName">
                </nz-form-control>
            </nz-form-item>
        </nz-col>
        <nz-col [nzFlex]="'auto'">
            <div class="form-actions">
                <button nz-button type="button" [nzType]="'primary'" (click)="search()"><i nz-icon
                        [nzType]="'search'"></i>
                    {{ resolveKey("Search") | translate}}</button>
                <button nz-button type="reset"><i nz-icon [nzType]="'undo'"></i>{{resolveKey("Reset") |
                    translate}}</button>
                <button nz-button type="button" (click)="addRole()"><i nz-icon
                        [nzType]="'plus'"></i>{{resolveKey("AddRole") | translate}}</button>
            </div>


        </nz-col>

    </nz-row>


</form>

<nz-table #table mm-table [entityName]="'role'">
    <thead>
        <tr>
            <th>
                {{resolveKey("RoleCode") | translate}}
            </th>
            <th>
                {{resolveKey("RoleName") | translate}}
            </th>
            <th>
                {{resolveKey("Operation") | translate}}
            </th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let item of table.data">
            <td>
                {{item.name }}
            </td>
            <td>
                {{item.displayName | localize }}
            </td>

            <td>
                <button  (click)="editRole(item)" nz-button [nzType]="'link'">
                    <i nz-icon nzType="edit"></i>
                </button>
                <mm-delete-icon (confirm)="delete(item)"></mm-delete-icon>
            </td>
        </tr>

    </tbody>

</nz-table>